module.exports = __webpack_public_path__ + "img/bg1.c2696e42.png";